module.exports = __webpack_public_path__ + "img/invite-get-stamp-dialog-img@3x.09db8d17.png";